import { ScrollBar } from "@components/scrollBar";
import { TFunction } from "i18next";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { IDashboardTileComponentProps } from "../../dashboard";
import {
    DashboardTileBackgroundStyled,
    DashboardTileHeaderStyled,
    KeyboardShortcutTileGrid,
    ShortcutDescription
} from "./KeyboardShortcutsTile.styles";

interface IProps extends IDashboardTileComponentProps, WithTranslation {

}


interface IKeyboardShortcutItemProps {
    shortcut: string;
    description: string;
}

const KeyboardShortcutItem: React.FC<IKeyboardShortcutItemProps> = (props) => {
    return (
        <>
            <div>{props.shortcut}</div>
            <ShortcutDescription>{props.description}</ShortcutDescription>
        </>
    );
};

const getMainShortcuts = (t: TFunction): IKeyboardShortcutItemProps[] => {
    return [
        { shortcut: "ALT + N", description: t("Home:KeyboardShortcuts.ALT_N") },
        { shortcut: "ALT + C", description: t("Home:KeyboardShortcuts.ALT_C") },
        { shortcut: "ALT + S", description: t("Home:KeyboardShortcuts.ALT_S") },
        { shortcut: "ALT + X", description: t("Home:KeyboardShortcuts.ALT_X") },
        { shortcut: "ALT + R", description: t("Home:KeyboardShortcuts.ALT_R") },
        { shortcut: "ALT + SHIFT + S", description: t("Home:KeyboardShortcuts.ALT_SHIFT_S") },
        { shortcut: "ALT + D", description: t("Home:KeyboardShortcuts.ALT_D") },
        { shortcut: "ALT + ↓", description: t("Home:KeyboardShortcuts.ALT_DOWN_ARROW") },
        { shortcut: "ALT + ↑", description: t("Home:KeyboardShortcuts.ALT_UP_ARROW") },
        { shortcut: "ALT + SHIFT + 1", description: t("Home:KeyboardShortcuts.ALT_SHIFT_1") },
        { shortcut: "ALT + SHIFT + 2", description: t("Home:KeyboardShortcuts.ALT_SHIFT_2") },
        { shortcut: "ALT + SHIFT + 3", description: t("Home:KeyboardShortcuts.ALT_SHIFT_3") },
    ];
};


const KeyboardShortcutsTile: React.FC<IProps> = (props) => {
    return (
        <DashboardTileBackgroundStyled backgroundColor={props.info.backgroundColor}
                                       inEditMode={props.inEditMode}>
            <DashboardTileHeaderStyled>{props.info.title}</DashboardTileHeaderStyled>
            <ScrollBar isInFlex>
                <KeyboardShortcutTileGrid>
                    {getMainShortcuts(props.t).map(shortcut =>
                        <KeyboardShortcutItem key={shortcut.shortcut}
                                              shortcut={shortcut.shortcut}
                                              description={shortcut.description}/>
                    )}
                </KeyboardShortcutTileGrid>

            </ScrollBar>
        </DashboardTileBackgroundStyled>
    );
};

export default withTranslation(["Home"])(React.memo(KeyboardShortcutsTile));